module.exports = urlToImage;

function urlToImage (url, fn) {
  var img = new Image();
  if (fn) img.onload = fn.bind(null, img);
  img.src = url;
  return img;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/fix-orientation/lib/url-to-image.js
// module id = 1417
// module chunks = 0